@if (pictures().length !== 0) {
  <div class="product-pictures-wrapper">
    @for (pics of pictures(); track $index) {
      <div class="product-picture-card">
        <img
          [src]="
            config.piaAPIOrigin + '/Document(' + pics.DocumentId + ')/$value'
              | authImage
          "
          alt=""
          class="product-picture"
        />
      </div>
    }
  </div>
}
